export default __webpack_public_path__ + "static/media/25-dont-store-customer-data.a555c83e.jpg";